export default __webpack_public_path__ + "static/hero-da57a2db3f6a1dc4778b92d64d21833f.jpg";